<template>
  <div class="content-box">
    <div class="contant-wrap content-body">
      <el-card>
        <el-row style="height: 35px;line-height: 35px;">
          <div style=" float: left;">
            <el-form :inline="true" :model="params" class="demo-form-inline">
              <el-form-item label="医生：">
                <el-input v-model="params.doctorName" placeholder="请输入医生名字" clearable style="width: 200px"></el-input>
              </el-form-item>
              <el-form-item label="患者：">
                <el-input v-model="params.keyWord" placeholder="请输入患者名字/电话" clearable style="width: 200px"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="small" @click="getRegisterRecord(params)">查询</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div style="float: right;">
            <el-button type="primary" size="small" @click="addRegister">新增挂号</el-button>
            <el-button type="primary" size="small" v-if="$store.state.global.isHiSuccess">
              <a href="webapi://" style="color: white;text-decoration: none;">启动程序</a>
            </el-button>
            <el-button @click="signIn" type="primary" size="small" v-if="$store.state.global.isHiSuccess">签到</el-button>
            <!-- <el-button @click="signOut" type="primary" size="small"
              v-if="$store.state.global.isHiSuccess">签退</el-button> -->
          </div>
        </el-row>
      </el-card>
      <el-card style="margin-top: 20px">
        <el-table :data="tableData" v-loading="loading" style="width: 100%">
          <el-table-column type="index" label="序号" width="60" align="center">
          </el-table-column>
          <el-table-column prop="patientName" label="患者姓名" align="center">
          </el-table-column>
          <el-table-column prop="sex" label="性别" align="center">
          </el-table-column>
          <el-table-column prop="birthday" label="出生日期" align="center">
          </el-table-column>
          <el-table-column prop="phone" label="电话" align="center">
          </el-table-column>
          <el-table-column prop="deptName" label="科室" align="center">
          </el-table-column>
          <el-table-column prop="doctorName" label="医生名字" align="center">
          </el-table-column>
          <el-table-column prop="medType" label="费用类型" align="center">
            <template slot-scope="scope">
              <!-- <el-tag v-if="scope.row.medType == 1">否</el-tag>
              <el-tag v-else type="warning">否</el-tag> -->
              <span v-if="scope.row.medType == 11">普通门诊</span>
              <span v-else-if="scope.row.medType == 9935">独立门诊部个人帐户支付</span>
              <span v-else>自费</span>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" align="center">
            <template slot-scope="scope">
              <span class="pending" v-show="scope.row.status === 2">待诊</span>
              <span v-show="scope.row.status === 3">已诊</span>
              <span class="cancelText" v-show="scope.row.status === 4">已取消</span>
              <span v-show="scope.row.status === 5">诊所取消</span>
              <span v-show="scope.row.status === 6">已过期</span>
            </template>
          </el-table-column>
          <el-table-column width="250" label="预约时间段" align="center">
            <template slot-scope="scope">
              {{ scope.row.startTime.substring(0, 16) + '-' + scope.row.endTime.substring(11, 16) }}
            </template>
          </el-table-column>
          <el-table-column width="250" label="创建时间" align="center">
            <template slot-scope="scope">
              {{ scope.row.gmtCreate }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="cancel(scope.row)" v-show="scope.row.status === 2">取消</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page.sync="params.page" :page-sizes="pageSizes" :page-size.sync="params.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </el-card>
      <el-dialog title="新增挂号" :visible.sync="dialogVisible" width="1100px" :before-close="handleClose">
        <el-form :model="form" :rules="rules" ref="form" hide-required-asterisk>
          <el-row :gutter="30">
            <!--  v-if="isHiSuccess" -->
            <el-col :span="12">
              <el-form-item>
                <el-radio-group v-model="cardReadingType" @change="cardReadingChange" class="reading-type"
                  v-if="form.medType != 1">
                  <el-radio label="01" border>电子凭证</el-radio>
                  <el-radio v-if="countInfo.cityCode == 197" label="02" border>身份证</el-radio>
                  <el-radio label="03" border>社保卡</el-radio>
                </el-radio-group>
                <!-- <el-radio-group v-model="form.resource">
                  <el-radio label="线上品牌商赞助" border></el-radio>
                  <el-radio label="线下场地免费" border></el-radio>
                </el-radio-group> -->
              </el-form-item>
            </el-col>
            <!--  v-if="isHiSuccess" -->
            <el-col :span="12">
              <div style="display: flex;">
                <el-form-item prop="doctorIds" style="flex: 1;">
                  <el-select v-model="form.doctorIds" placeholder="请选择医生" class="select-left" style="width: 100%;">
                    <el-option v-for="item in doctorList" :label="item.value + ''" :value="item.key + ''"
                      :key="item.key + ''"></el-option>
                  </el-select>
                </el-form-item>
                <el-select v-model="form.scheduleId" :placeholder="'请选择医生排班'" class="select-center" style="width: 35%;">
                  <el-option v-for="(item, index) in schedulingList" :key="index"
                    :label="item.startTime.substring(0, 16) + '~' + item.endTime.substring(11, 16)"
                    :value="item.scheduleId">
                  </el-option>
                </el-select>
                <el-select v-model="form.medType" placeholder="请选择费用类型" class="select-right" style="width: 25%;" :disabled="isHiSuccess ? false : true">
                  <el-option label="自费" :value="1"></el-option>
                  <el-option label="普通门诊" :value="11" v-if="countInfo.cityCode == 197"></el-option>
                  <el-option label="独立门诊部个人帐户支付" :value="9935" v-if="countInfo.cityCode == 3401"></el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :span="24"></el-col>
            <el-col :span="8">
              <el-form-item label="患者姓名：" prop="psn_name">
                <!-- <el-input placeholder="请输入患者姓名" v-model="form.psn_name"
                  :disabled="isHiSuccess && form.medType != 1"></el-input> -->
                <el-autocomplete v-model="form.psn_name" style="width: 100%;"
                  popper-class="patient-list-autocomplete add-autocomplete-header" prefix-icon="el-icon-user-solid"
                  v-autocomplete-scroll="patientHandleScroll" ref="patientListAutocomplete"
                  :disabled="isHiSuccess && form.medType != 1" :fetch-suggestions="querySearchPatient"
                  placeholder="请输入患者姓名/电话号码" @select="handleSelect">
                  <template slot-scope="slotProps">
                    <div class="search-item autocomplete-header" style="width: 600px;" v-if="slotProps.item.isHeader">
                      <div style="flex: 2;">姓名</div>
                      <div>性别</div>
                      <div style="flex: 5;"> 年龄 </div>
                      <div style="flex: 4;"> 手机号码 </div>
                      <div style="flex: 4;">最近就诊时间</div>
                    </div>
                    <div class="search-item" style="width: 600px;" v-else>
                      <div style="flex: 2;">{{ slotProps.item.patientName }}</div>
                      <div>{{ slotProps.item.gender | setGender }}</div>
                      <div style="flex: 5;">
                        {{ slotProps.item.birthday }} &nbsp;
                        {{ slotProps.item.yearMonthDay }}
                      </div>
                      <div style="flex: 4;">{{ slotProps.item.phoneNo }}</div>
                      <div style="flex: 4;">{{ slotProps.item.diagnosisDate }}</div>
                    </div>
                  </template>
                </el-autocomplete>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="年龄：">
                <div class="age-box">
                  <el-input v-model="form.year" maxlength=3 @blur="getBirthday"
                    :disabled="isHiSuccess && form.medType != 1">
                    <template slot="append">岁</template>
                  </el-input>
                  <el-input v-model="form.month" maxlength=2 @blur="getBirthday"
                    :disabled="isHiSuccess && form.medType != 1">
                    <template slot="append">月</template>
                  </el-input>
                  <el-input v-model="form.day" maxlength=2 @blur="getBirthday"
                    :disabled="isHiSuccess && form.medType != 1">
                    <template slot="append">天</template>
                  </el-input>
                </div>
                <!-- <el-input v-model="form.age" :disabled="isHiSuccess && form.medType != 1"></el-input> -->
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="性别：" prop="gender" style="margin-bottom: 40px;">
                <el-radio-group v-model="form.gender" :disabled="isHiSuccess && form.medType != 1" style="width: 100%;">
                  <el-radio label="1">男</el-radio>
                  <el-radio label="0">女</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="出生日期：">
                <el-date-picker v-model="form.bir" :disabled="isHiSuccess && form.medType != 1" type="date"
                  placeholder="选择日期" @blur="getAge" :editable="false" :clearable="false" style="width: 100%;"
                  :picker-options="pickerOptions1" value-format="yyyy-MM-dd"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="身份证号码：">
                <el-input placeholder="请输入患者身份证号码" v-model="form.certno" :disabled="isHiSuccess && form.medType != 1"
                  @input="certNoChamge"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="手机号码：">
                <el-input placeholder="请输入有效手机号码" v-model="form.phone"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="民族：">
                <!-- <el-input v-model="form.naty" :disabled="isHiSuccess && form.medType != 1"></el-input> -->
                <el-select v-model="form.naty" placeholder="请选择民族" :disabled="isHiSuccess && form.medType != 1"
                  style="width: 100%;">
                  <el-option v-for="item in nationList" :key="item.value" :label="item.value" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!--<el-col :span="8" v-if="isHiSuccess">-->
            <!--  <el-form-item prop="doctorIds" style="flex: 1;">-->
            <!--    <el-select v-model="form.doctorIds" placeholder="请选择医生" style="width: 100%;">-->
            <!--      <el-option :label="item.value" :value="item.key" v-for="item in doctorList"-->
            <!--        :key="item.key"></el-option>-->
            <!--    </el-select>-->
            <!--  </el-form-item>-->
            <!--</el-col>-->
            <!--<el-col :span="8" v-if="isHiSuccess">-->
            <!--  <el-form-item prop="doctorIds" style="flex: 1;">-->
            <!--    <el-select v-model="form.scheduleId" placeholder="请选择医生排班" style="width: 100%;">-->
            <!--      <el-option v-for="(item, index) in schedulingList" :key="index"-->
            <!--        :label="item.startTime.substring(0, 16) + '~' + item.endTime.substring(11, 16)"-->
            <!--        :value="item.scheduleId">-->
            <!--      </el-option>-->
            <!--    </el-select>-->
            <!--  </el-form-item>-->
            <!--</el-col>-->
            <el-col :span="8" v-if="isHiSuccess && form.medType != 1">
              <el-form-item label="险种">
                <el-select v-model="form.insutype" placeholder="请选择" style="width: 100%;">
                  <el-option v-for="item in personInfo.personnelInsuinfoList" :key="item.insutype"
                    :label="item.insutypeName" :value="item.insutype">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="isHiSuccess && form.medType != 1">
              <el-form-item label="账户余额">
                <el-input disabled
                  :value="optionsLabelGetter(personInfo.personnelInsuinfoList || [], form.insutype, 'insutype', 'balc')">
                  <template slot="suffix">元</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="isHiSuccess && form.medType != 1">
              <el-form-item label="参保区划">
                <el-input disabled
                  :value="optionsLabelGetter(personInfo.personnelInsuinfoList || [], form.insutype, 'insutype', 'insuplcAdmdvs')">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div style="text-align: center">
          <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
          <el-button size="mini" type="primary" @click="register('form')">确定</el-button>
        </div>
        <!-- <el-button @click="initReadCard">点击初始化</el-button> -->
        <!-- <el-button @click="getIp">点击获取ip</el-button> -->
        <el-dialog width="30%" title="读卡" :visible.sync="innerVisible" append-to-body>
          <el-row>
            <el-radio-group v-model="radio" @input="selectRadio" style="display: flex;justify-content: center;">
              <el-radio :label="1" border>电子凭证</el-radio>
              <el-radio :label="2" border>身份证</el-radio>
              <el-radio :label="3" border>社保卡</el-radio>
            </el-radio-group>
          </el-row>
          <el-row type="flex" justify="center" style="margin: 50px 0">
            <img src="../../../assets/home/Vector@2x.png" style="width: 180px; height: 112px" />
          </el-row>
        </el-dialog>
        <!-- <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span> -->
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { pageSizes, pickerOptions } from "@/config/constant";
import { getFormatDate2 } from "@/utils/insurance/index";
import { validatePhone } from "@/utils/validate/elementMethod";
import { setToday } from "@/utils/filter/index";
import Store from "@/utils/localStore/index";
import { getMac } from "@/utils/getMac.js";
import { getDataValue, optionsLabelGetter } from '@/utils/util.js';
import {registerAPINew} from "@/api/workbench";
const autocompleteScroll = {
  bind (el, binding, vnode) {
    // 此处为了简单，直接判断触底了
    function handleScroll (e) {
      let isBottom =
        e.target.clientHeight + e.target.scrollTop == e.target.scrollHeight
      if (isBottom && !vnode.context.loading) {
        binding.value()
      }
    }
    // 监听滚动
    let wrapDom = el.querySelector('.el-autocomplete-suggestion__wrap')
    el.__handleScroll__ = handleScroll
    el.__wrapDom__ = wrapDom
    wrapDom.addEventListener('scroll', handleScroll, false)
  },

  unbind (el, binding, vnode) {
    console.log('unbind')
    // 解除事件监听
    el.__wrapDom__.removeEventListener('scroll', el.__handleScroll__, false)
  }
}
export default {
  name: "register",
  data () {
    return {
      loading: false,
      innerVisible: false, //读卡弹窗
      doctorName: "",
      keyWord: "",
      patientName: "",
      laboratoryList: [], //科室列表
      insuDeptList: [], //诊所医保科室列表
      doctorList: [], //医生列表
      isInsuRegister: false,
      pageSizes,
      tableData: [], //PC端挂号记录
      total: 0,
      dialogVisible: false,
      medTypeOptions: [
        { value: "11", label: "普通门诊", },
        { value: "14", label: "门诊慢特病", },
      ],
      medType: "", //医疗类别
      gender: "",
      form: {
        psn_name: "",
        age: "",
        bir: "",
        phone: "",
        naty: "汉族",
        chronic: "",
        gender: "0",
        dept_code: "", //科室编码 A03
        dept_name: "", //内科
        caty: "", //科别 A03
        atddr_no: "", //医生编码 D430111022228
        dr_name: "", //孙玲
        psn_no: "", //人员编号
        mdtrt_cert_type: "01", //就诊凭证类型
        mdtrt_cert_no: "", //就诊凭证编号
        insutype: "", //险种
        doctorId: "", //医生id
        doctorIds: "", //医生id
        laboratoryId: "", //科室id
        certno: "",
        settingExtendId: "", //挂号要传入的排班id
        scheduleId: "", //获取到的排班id
        hiType: "1", //是否使用医保 0否1是
        medType: 1,
        year: '',
        month: '',
        day: ''
      }, //挂号信息
      rules: {
        psn_name: [{ required: true, message: "请输入患者姓名", trigger: "change" },],
        certno: [{ required: true, message: "请输入身份证号", trigger: "change" },],
        phone: [{ required: true, validator: validatePhone, trigger: "change" }],
        gender: [{ required: true, message: "请选择性别", trigger: "change" }],
        laboratoryId: [{ required: true, message: "请选择科室", trigger: "change" },],
        laboratoryName: [{ required: true, message: "请输入科室", trigger: "change" },],
        doctorId: [{ required: true, message: "请选择医生", trigger: "change" }],
        doctorName: [{ required: true, message: "请输入医生", trigger: "change" }],
        insutype: [{ required: true, message: "请选择险种", trigger: "change" }],
        scheduleId: [{ required: true, message: "请选择挂号时间", trigger: "change" },],
        doctorIds: [{ required: true, message: "请选择科室-医生", trigger: "change" }],
      },
      insuTypeList: [], //险种数组
      params: {
        startTime: "",
        endTime: "",
        laboratoryId: -1,
        doctorId: "",
        doctorName: "",
        status: -1, //预约状态
        keyWord: "", //患者名字或电话
        pageSize: 20,
        page: 1,
        hiSource: "1", // 0：H5端 1 PC端
      },
      query: {
        laboratoryId: "",
      },
      radio: 0, //读卡选项
      form1: {
        mdtrt_cert_type: "",
        mdtrt_cert_no: "",
        card_sn: "", //卡识别码 选社保卡时必传
        psn_cert_type: "", //人员证件类型 选社保卡时必传
        certno: "", //人员证件号码 选社保卡时必传
      }, //获取人员信息需要的参数
      schedulingList: [], //医生排班列表
      opspDiseasesList: [
        // { opsp_dise_code: '01', opsp_dise_name: '高血压' },
        // { opsp_dise_code: '01', opsp_dise_name: '高血压' }
      ], //慢特病列表
      currentIp: "",
      currentMac: "",
      doctorList: [], //医生列表
      cardReadingType: "", //读卡类型
      electronicVoucherForm: {},//电子凭证信息
      electronicVoucherData: {},//电子凭证数据
      socialSecurityCardForm: {},//社保卡信息
      socialSecurityCardData: {},//社保卡数据
      idCardData: {},//身份证数据
      idCardForm: {},//身份证信息
      personInfo: {
        personnelInsuinfoList: []
      },
      pickerOptions1: {
        disabledDate (time) {
          return time.getTime() > Date.now();
        },
      },
      PatientListPages: 1,//患者信息列表总页码
      PatientListPage: 1, //患者信息列表页码
      nationList: [],// 民族列表
    };
  },
  mounted () {
    this.getRegisterRecord(this.params);
    this.getDepartment();
    this.getDoctorList();
    this.getNationList();
    // this.getIpAndMac()
    // this.recurrentInfo()
    if (this.isHiSuccess) {
      if (this.countInfo.cityCode == 197) {
        this.form.medType = 11
      } else {
        this.form.medType = 9935
      }
    } else {
      this.form.medType = 1
    }
  },
  directives: {
    autocompleteScroll
  },
  methods: {
    // 分页加载
    async patientHandleScroll () {
      // 限制翻页限度
      if (this.PatientListPage > this.PatientListPages) {
        return
      }
      this.PatientListPage++
      let list = await this.getPatientList(this.form.psn_name)
      this.$refs['patientListAutocomplete'].$data.suggestions.push(...list)
    },
    // 获取患者信息列表
    async getPatientList (queryString) {
      this.form.psn_name = queryString || this.form.psn_name
      let res = await this.$api.outPatient.listclinicPatientByNameOrPhone({ patientName: this.form.psn_name, page: this.PatientListPage, pageSize: 10 })
      this.PatientListPages = res.pages
      let list = [];
      list = res.records.map(item => ({ ...item, ageCom: `${item.age}${item.ageType}` }));
      return list
    },
    // 根据会员电话或者姓名查询下拉框
    async querySearchPatient (queryString, cb) {
      let list = [];
      list = await this.getPatientList(queryString);
      if (list.length > 0) {
        // 第一项添加
        list.push({ isHeader: true, label: '' })
      }
      cb(list);
    },
    handleSelect (row) {
      this.form.psn_name = row.patientName
      this.form.year = row.year
      this.form.month = row.month
      this.form.day = row.day
      this.form.certno = row.idCardNo
      this.form.phone = row.phoneNo
      this.form.gender = row.gender + ''
      this.getBirthday()
    },
    handleClick (row) {
    },
    handleClose (done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => { });
    },
    getInfoTest () {
      const params = {
        mdtrt_cert_type: "02",
        // certno:'431102199110023853'
        // mdtrt_cert_no:'430422199508090168'
        mdtrt_cert_no: '43038119990617234X'//李湘钰
        //mdtrt_cert_no:'430621198410142759'
        // mdtrt_cert_no:'430382199412281059'
        // mdtrt_cert_no: "430121199409036710",
        // mdtrt_cert_no: "34012119811225581X",
      };
      this.getInfo(params);
    },
    getInfo (obj) {
      // const params = {
      //   mdtrt_cert_type: '02',
      //   // certno:'431102199110023853'
      //   mdtrt_cert_no:'430422199508090168'
      // }
      this.$api.newInsurance.getPatientInfoAPI(obj).then((res) => {
        // console.log(res, "人员信息");
        if (res.data.code == 200) {
          this.$message({
            message: "获取人员信息成功",
            type: "success",
          });
          const { data } = res.data;
          this.form.age = Math.floor(data.age)
          this.form.bir = data.brdy.substring(0, 10);
          this.form.naty = data.naty;
          this.form.gender = data.gend;
          this.form.psn_no = data.psnNo;
          this.form.psn_name = data.psnName;
          this.form.mdtrt_cert_type = data.mdtrtCertType;
          this.form.mdtrt_cert_no = data.mdtrtCertNo;
          this.form.psn_cert_type = data.psnCertType;
          this.form.begntime = getFormatDate2();
          this.form.certno = data.certno;
          this.form.psn_type = "11";
          this.form.phone = data.phone;
          this.insuTypeList = data.personnelInsuinfoList;
          // 默认展示职工基本医疗保险
          if (this.insuTypeList.some((item) => item.insutype == "310")) {
            this.form.insutype = "310";
          } else {
            this.form.insutype = this.insuTypeList[0].insutype;
          }
          // 处理慢特病数据
          if (data.chronicIdiopathyList != null) {
            this.opspDiseasesList = data.chronicIdiopathyList;
            const arr = [];
            data.chronicIdiopathyList.forEach((item) => {
              arr.push(item.opsp_dise_name);
            });
            // console.log(arr, "arr");
            this.form.chronic = arr.join(",");
            // console.log(this.form.chronic, "this.form.chronic");
          } else {
            this.form.chronic = "无";
          }
        } else {
          this.$message({
            type: "error",
            message: res.data.message,
          });
        }
      });
    },
    async register (formName) {
      // let balc = optionsLabelGetter(this.personInfo.personnelInsuinfoList || [], '310', 'insutype', 'insutypeName', 0)
      // if (!balc && this.isHiSuccess) {
      //   let e = await this.$confirm('账户余额为零，是否继续挂号？', '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   })
      //   console.log("🚀 ~ register ~ e:", e)
      //   if (e != 'confirm') {
      //     return
      //   }
      // }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let req = this.form.medType !== 1 ? this.$api.workbench.registerAPI : this.$api.workbench.registerAPINew
          req(this.form).then((res) => {
            // console.log(res, "挂号信息");
            let flag = this.form.medType !== 1 ? res.data.code == 200 : res
            if (flag) {
              this.$message({
                type: "success",
                message: "挂号成功",
              });
              this.dialogVisible = false;
              this.getRegisterRecord(this.params);
              this.$refs[formName].resetFields();
              this.form = {
                psn_name: "",
                age: "",
                bir: "",
                phone: "",
                naty: "",
                chronic: "",
                gender: "",
                dept_code: "", //科室编码 A03
                dept_name: "", //内科
                caty: "", //科别A03
                atddr_no: "", //医生编码D430111022228
                dr_name: "", //孙玲
                psn_no: "", //人员编号
                mdtrt_cert_type: "01", //就诊凭证类型
                mdtrt_cert_no: "", //就诊凭证编号
                insutype: "", //险种
                doctorId: "", //医生id
                hiType: "1", //是否使用医保 0否1是
                sn_name: "",
                doctorIds: "", //医生id
                laboratoryId: "", //科室id
                certno: "",
                settingExtendId: "", //挂号要传入的排班id
                scheduleId: "", //获取到的排班id
                medType: 1,
                year: '',
                month: '',
                day: ''
              };
            } else {
              this.$message({ type: "error", message: res.data.message });
            }
          });
        } else {
          // console.log("error submit!!");
          return false;
        }
      });
    },
    // 获取挂号记录
    getRegisterRecord (obj) {
      this.loading = true;
      this.$api.workbench.getHospitalSubList(obj).then((res) => {
        // console.log(res, "挂号记录");
        this.tableData = res.list;
        this.total = res.totalCount;
        this.loading = false;
      });
    },
    handleSizeChange (val) {
      // console.log(val,'val');
      this.params.pageSize = val;
      this.getRegisterRecord(this.params);
    },
    handleCurrentChange (val) {
      this.params.page = val;
      this.getRegisterRecord(this.params);
    },
    cancel (item) {
      // console.log(item,'item');
      const params = {
        register_id: item.idStr,
      };
      console.log(item)
      this.$confirm("确定取消吗?", "取消预约", {
        confirmButtonText: "确定",
        cancelButtonText: "关闭",
        type: "warning",
      }).then(() => {
        let urlFile = item.medType !== 1 ? 'newInsurance' : 'workbench'
        let url = item.medType !== 1 ? 'cancelRegisterAPI' : 'cancelRegisterHis'
        this.$api[urlFile][url](params)
          .then((res) => {
            // console.log(res, "取消成功");
            if(item.medType !== 1) {
              if(res.data.code == 200) {
                if (result) {
                  this.$message({
                    message: "取消成功",
                    type: "success",
                  });
                } else {
                  this.$message({
                    message: res.data.message,
                    type: "error",
                  });
                }
              }
            }else {
              this.$message({
                message: "取消成功",
                type: "success",
              });
            }
          })
          .then(() => {
            this.getRegisterRecord(this.params);
          });
      });
    },
    // 通过医生名字搜索
    getSubListByName () {
      this.params.doctorName = this.doctorName;
      // console.log(this.params.doctorName, "医生名字");
      this.getRegisterRecord(this.params);
    },
    // 通过患者名字或电话搜索
    keyWordChange () {
      this.params.keyWord = this.keyWord;
      // console.log(this.params.keyWord, "患者名字");
      this.getRegisterRecord(this.params);
    },
    // 获取科室列表
    getDepartment () {
      this.$api.clinicManagement.getListLaboratory().then((res) => {
        // console.log("诊所科室列表", res);
        this.laboratoryList = res;
        this.insuDeptList = res.filter((item) => item.hiHiName.length > 0);
        // console.log("诊所医保科室列表",this.insuDeptList);
        // this.getDoctor();
      });
    },
    // 获取科室对应的人员列表
    selectDept (val) {
      console.log(val, "科室id");
      if (val) {
        this.query.laboratoryId = val;
      }
      // 选中医保才处理

      // const selected = this.insuDeptList.find(
      //   (item) => item.laboratoryId == val
      // );
      // console.log(selected,'selected');
      // this.form.dept_code = selected.hiHiCode;
      // this.form.dept_name = selected.hiHiName;
      // this.form.laboratoryName = selected.laboratoryName;
      // this.form.caty = selected.hiHiCode;
      // console.log(this.form,'form');
      this.$api.clinicManagement
        .getDoctorListByLaboratoryAPI(this.query)
        .then((res) => {
          // console.log(res, "科室人员");
          this.doctorList = res;
        });
    },
    selectDoctor (val) {
      // console.log(val,'医生id');
      const selected = this.doctorList.find((item) => item.doctorId == val);
      this.form.dr_name = selected.realName;
      this.form.atddr_no = selected.hiPhysicianCode;
      this.getSchedule(val)
    },
    // 获取医生当天排班信息
    getSchedule (value) {
      this.$api.workbench.getDoctorSchedulingAPI({
        doctorId: value,
        workDay: setToday(),
      }).then((res) => {
        // console.log(res, "医生排班列表");
        this.schedulingList = res;
      });
    },
    selectTime (val) {
      this.form.settingExtendId = val;
      // console.log(this.form,'form');
    },
    getIp () {
      // this.innerVisible = true
      this.$api.newInsurance.getIpAPI().then((res) => {
        // console.log(res,'ip地址');
      });
    },
    initReadCard () {
      // const params = {
      //   url: "http://10.93.28.229:80/hsa-hgs-adapt/api/card/initDll",
      //   User: "430100|10.93.28.229:80",
      // };
      const { fixMedIns } = Store.get("vuex").global.countInfo
      const params = {
        url: fixMedIns.apiUrl,
        User: fixMedIns.useArea,
      };
      this.$api.newInsurance.initReadCardAPI(params).then((res) => {
        // console.log(res,'初始化');
      });
    },
    // 读取身份证号
    async getIdCode () {
      await this.initReadCard();
      this.$api.newInsurance.getCardNoAPI().then((res) => {
        if (res.data.code == 0) {
          this.$message({
            type: "success",
            message: "读取身份证号成功",
          });
          // console.log(res, "获取身份证号");
          const { model } = res.data;
          this.form1.mdtrt_cert_no = model.cardNo;
          // console.log(this.form1,'form1')
          if (this.form1.mdtrt_cert_no) {
            this.innerVisible = false;
            this.getInfo(this.form1);
          }
        } else {
          this.$message({
            type: "error",
            message: "读取身份证号失败，请检查是否放置身份证",
          });
        }
      });
    },
    // 读取社保卡号
    async getSbCode () {
      await this.initReadCard();
      this.$api.newInsurance.getSocialCardNoAPI().then((res) => {
        if (res.data.code == 0) {
          this.$message({
            type: "success",
            message: "读取社保卡号成功",
          });
          // console.log(res, "获取社保卡号");
          const { model } = res.data;
          this.form1.mdtrt_cert_no = model.cardNo;
          this.form1.card_sn = model.identificationNo;
          this.form1.certno = model.cardNo;
          // console.log(this.form1,'form1');
          if (this.form1.mdtrt_cert_no) {
            this.innerVisible = false;
            this.getInfo(this.form1);
          }
        } else {
          this.$message({
            type: "error",
            message: "读取社保卡号失败",
          });
        }
      });
    },
    // 电子凭证获取信息
    getElectronicVoucher () {
      // const params = {
      //   url: "http://10.93.28.230:80/localcfc/api/hsecfc/localQrCodeQuery",
      //   data: '{"data":{"businessType":"01101","deviceType":"","officeId":"32760","officeName":"消化内科","operatorId":"test001","operatorName":"超级管理员","orgId":"H43010200354"},"orgId":"H43010200354","transType":"ec.query"}',
      // };
      const { fixMedIns } = Store.get("vuex").global.countInfo
      const { countInfo } = Store.get("vuex").global
      const query = {
        data: {
          businessType: '01101',
          deviceType: '',
          officeId: '32760',
          officeName: '消化内科',
          operatorId: countInfo.doctorId,
          operatorName: countInfo.doctorName,
          orgId: fixMedIns.fixmedinsCode
        },
        orgId: fixMedIns.fixmedinsCode,
        transType: 'ec.query'
      }
      const params = {
        url: fixMedIns.tradeUrl,
        data: JSON.stringify(query),
      };
      this.$api.newInsurance.getElectronicVoucherAPI(params).then((res) => {
        // console.log(res, "电子凭证获取信息");
        if (res.data.code == 0) {
          this.$message({
            type: "success",
            message: "电子凭证获取信息成功",
          });
          const { data } = res.data;
          this.form1.mdtrt_cert_no = data.ecToken;
          this.form1.psn_cert_type = data.idType;
          this.form1.certno = data.idNo;
          this.form1.psn_name = data.userName;
          // console.log(this.form1,'form1')
          if (this.form1.mdtrt_cert_no) {
            this.innerVisible = false;
            this.getInfo(this.form1);
          }
        } else {
          this.$message({
            type: "error",
            message: "电子凭证获取信息失败",
          });
        }
      });
    },
    // 选中的radio值
    selectRadio (val) {
      // console.log(val,'选中的radio值');
      if (val == "2") {
        this.form1.mdtrt_cert_type = "0" + val;
        // console.log(this.form1.mdtrt_cert_type,'form1.mdtrt_cert_type');
        this.getIdCode();
      } else if (val == "3") {
        this.form1.mdtrt_cert_type = "0" + val;
        this.form1.psn_cert_type = "90";
        // console.log(this.form1.mdtrt_cert_type,'form1.mdtrt_cert_type');
        this.getSbCode();
      } else if (val == "1") {
        this.form1.mdtrt_cert_type = "0" + val;
        this.getElectronicVoucher();
      }
    },
    // 获取本机ip和mac地址
    getIpAndMac () {
      this.$api.newInsurance.getIpAndMacAPI().then((res) => {
        // console.log(res, "本机ip和mac地址");
        if (res.status == 200 && res.data != null) {
          this.currentIp = res.data.ip
          this.currentMac = res.data.mac
        } else {
          this.$message({
            type: "error",
            message: res.statusText,
          });
        }
      });
    },
    async signIn () {
      try {
        const res = await this.$api.newInsurance.getIpAndMacAPI()
        console.log(res, 'res');
        if (res.status == 200 && res.data != null) {
          this.currentIp = res.data.ip
          this.currentMac = res.data.mac
        } else {
          this.$message({
            type: "error",
            message: res.statusText,
          });
        }
      } catch (error) {
        this.$message({
          type: "error",
          message: "未启用读卡程序，无法签到",
        });
      }
      if (!this.currentIp && !this.currentMac) {
        return
      }
      const params = {
        ip: this.currentIp,
        mac: this.currentMac
        // ip:'192.168.10.100',
        // mac:'58-11-22-29-E7-B4'
      }
      this.$api.newInsurance.signInAPI(params).then((res) => {
        // console.log(res,'签到');
        if (res.data.code == 200) {
          this.$message({
            type: "success",
            message: "签到成功",
          });
        } else {
          this.$message({
            type: "error",
            message: res.data.message,
          });
        }
      });
    },
    async signOut () {
      try {
        const res = await this.$api.newInsurance.getIpAndMacAPI()
        console.log(res, 'res');
        if (res.status == 200 && res.data != null) {
          this.currentIp = res.data.ip
          this.currentMac = res.data.mac
        } else {
          this.$message({
            type: "error",
            message: res.statusText,
          });
        }
      } catch (error) {
        this.$message({
          type: "error",
          message: "未启用读卡程序，无法签退",
        });
      }
      if (!this.currentIp && !this.currentMac) {
        // this.$message({
        //   type: "error",
        //   message: "未启用读卡程序，无法签退",
        // });
        return
      }
      const params = {
        ip: this.currentIp,
        mac: this.currentMac
        // ip:'192.168.10.100',
        // mac:'58-11-22-29-E7-B4'
      }
      this.$api.newInsurance.signOutAPI(params).then((res) => {
        // console.log(res,'签退');
        if (res.data.code == 200) {
          this.$message({
            type: "success",
            message: "签退成功",
          });
        } else {
          this.$message({
            type: "error",
            message: res.data.message,
          });
        }
      });
    },
    // 非管理员挂号信息回填
    recurrentInfo () {
      // console.log(this.countInfo,'this.countInfo');
      // 必验项调整
      if (this.isAdmin) {
        // 管理员
        this.rules.laboratoryName[0].required = false
        this.rules.doctorName[0].required = false
      } else {
        this.rules.laboratoryId[0].required = false
        this.rules.doctorId[0].required = false
      }
      // 险种是否必验
      if (this.form.hiType == '0') {
        this.rules.insutype[0].required = false
      } else {
        this.rules.insutype[0].required = true
      }
      if (!this.isAdmin) {
        if (this.form.hiType == '1') {
          // 走医保
          if (this.registerFlag) {
            // 有医保资质
            // 展示
            // this.form.laboratoryName = this.countInfo.laboratoryName
            // this.form.doctorName = this.countInfo.doctorName
            this.$set(this.form, 'laboratoryName', this.countInfo.laboratoryName)
            this.$set(this.form, 'doctorName', this.countInfo.doctorName)
            // 传参
            this.form.dept_code = this.countInfo.hiHiCode
            this.form.dept_name = this.countInfo.hiHiName
            this.form.caty = this.countInfo.hiHiCode
            this.form.atddr_no = this.countInfo.hiMedicineCode || this.countInfo.hiPhysicianCode
            this.form.dr_name = this.countInfo.doctorName
            this.form.doctorId = this.countInfo.doctorId
            this.form.laboratoryId = this.countInfo.laboratoryId
            // 获取医生排班信息
            this.getSchedule(this.countInfo.doctorId)
          } else {
            // console.log(this.form,'form');
            this.$message({
              type: "warning",
              message: "您没有医保资质，不能使用医保挂号",
            });
          }
        } else {
          // 没有勾选医保，默认展示当前医生和科室
          // this.form.laboratoryName = this.countInfo.laboratoryName
          this.$set(this.form, 'laboratoryName', this.countInfo.laboratoryName)
          this.$set(this.form, 'doctorName', this.countInfo.doctorName)
          // this.form.doctorName = this.countInfo.doctorName
          // 传参
          this.form.doctorId = this.countInfo.doctorId
          this.form.laboratoryId = this.countInfo.laboratoryId
          // console.log(this.form,'form');
          // 获取医生排班信息
          this.getSchedule(this.countInfo.doctorId)
        }
      }

    },
    // 医保勾选状态切换
    selectType (val) {
      // 险种是否必验
      if (val == '0') {
        this.rules.insutype[0].required = false
      } else {
        this.rules.insutype[0].required = true
      }
      // 假设先选了科室，再修改了勾选值，需要先把填写的信息清空
      // this.form.laboratoryId = ''
      // this.form.laboratoryName = ''
      // this.form.doctorId = ''
      // this.form.doctorName = ''
      // this.form.scheduleId = ''
      this.$set(this.form, 'laboratoryId', '')
      this.$set(this.form, 'laboratoryName', '')
      this.$set(this.form, 'doctorId', '')
      this.$set(this.form, 'doctorName', '')
      this.$set(this.form, 'scheduleId', '')
      this.$refs.form.clearValidate();
      this.recurrentInfo()
    },
    // 点击新增挂号
    addRegister () {
      // 每次新增都需要获取医生信息
      this.getDoctorList()
      this.dialogVisible = true
      let doctorList = this.doctorList
      let row = doctorList.length > 0 ? doctorList.find(item => item.key && item.key.indexOf(this.countInfo.doctorId) != -1) : doctorList[0]
      this.form.doctorIds = row ? row.key : ''
      if (this.isHiSuccess) {
        if (this.countInfo.cityCode == 197) {
          this.form.medType = 11
        } else {
          this.form.medType = 9935
        }
      } else {
        this.form.medType = 1
      }
      this.recurrentInfo()
    },
    async getDoctorList () {
      let params = {
        // costType: this.form.inquiryInfo.hiMedType
      }
      if (this.countInfo.isAdmin != 1) {
        params.doctorId = this.countInfo.doctorId
      }
      let res = await this.$api.outPatient.getDoctorList(params)
      // if (!this.form.inquiryInfo.doctorIds) {
      //   let obj = res.length > 0 ? res.find(item => item.key && item.key.indexOf(this.countInfo.doctorId) != -1) : {}
      //   this.form.inquiryInfo.doctorIds = obj ? obj.key : ''
      // }
      this.doctorList = res
    },
    //  
    cardReadingChange (e) {
      try {
        if (e == '01') {
          // if (this.isElectPay) {
          //   this.getElectronicVoucher('01301');// 结算 01301
          // } else {
          this.getElectronicVoucher('01101'); // 挂号 01101
          // }
        } else if (e == '02') {
          this.getIdCode()
        } else if (e == '03') {
          this.getSbCode()
        }
      } catch (error) {
        this.cardReadingType = ''
      }
    },
    // 读取电子凭证
    async getElectronicVoucher (businessType) {
      const query = {
        data: {
          // businessType:'01101',
          businessType: businessType,
          deviceType: '',
          officeId: '32760',
          officeName: '消化内科',
          operatorId: this.countInfo.doctorId,
          operatorName: this.countInfo.doctorName,
          orgId: this.countInfo.fixMedIns.fixmedinsCode
        },
        orgId: this.countInfo.fixMedIns.fixmedinsCode,
        transType: 'ec.query'
      }
      const params = { url: this.countInfo.fixMedIns.tradeUrl, data: JSON.stringify(query), };
      let res = await this.$api.newInsurance.getElectronicVoucherAPI(params)
      console.log('res: ', res.data.code);
      if (res.data.code == 0) { // 挂号
        this.$message.success("电子凭证获取信息成功");
        const { data } = res.data;
        this.electronicVoucherForm.mdtrt_cert_no = data.ecToken;
        this.electronicVoucherForm.psn_cert_type = data.idType;
        this.electronicVoucherForm.certno = data.idNo;
        this.electronicVoucherForm.psn_name = data.userName;
        this.electronicVoucherForm.areaNo = data.insuOrg;
        this.electronicVoucherData = data
        if (this.electronicVoucherForm.mdtrt_cert_no) {
          let formData = {
            ...this.electronicVoucherForm,
            mdtrt_cert_type: this.cardReadingType,
          }
          await this.getPatientInfoByReadCard(formData);
          await this.$nextTick()
          this.cardReadingType = ''
        } else {
          console.log('电子凭证获取信息失败');
          this.cardReadingType = ''
          this.$message.error(res.data.message || "电子凭证获取信息失败");
        }
      } else {
        this.cardReadingType = ''
        this.$message.error(res.data.message || "电子凭证获取信息失败");
      }
    },
    // 读取社保卡号
    async getSbCode () {
      await this.initReadCard();
      let res = await this.$api.newInsurance.getSocialCardNoAPI()
      if (res.data.code == 0) {
        this.$message.success("读取社保卡号成功");
        const { model } = res.data;
        this.socialSecurityCardForm.mdtrt_cert_no = model.cardNo;
        this.socialSecurityCardForm.card_sn = model.identificationNo;
        this.socialSecurityCardForm.certno = model.shbzhmSocialSecurityNo;
        this.socialSecurityCardForm.psn_name = model.name;
        this.socialSecurityCardForm.areaNo = model.areaNo;
        this.socialSecurityCardForm.psn_cert_type = '90';
        this.socialSecurityCardData = model
        if (this.socialSecurityCardForm.mdtrt_cert_no) {
          let formData = {
            ...this.socialSecurityCardForm,
            mdtrt_cert_type: this.cardReadingType,
          }
          await this.getPatientInfoByReadCard(formData);
          await this.$nextTick()
          this.cardReadingType = ''
        }
      } else {
        this.cardReadingType = ''
        this.$message.error(res.data.message || "读取社保卡号失败");
      }
    },
    // 读取身份证号
    async getIdCode () {
      await this.initReadCard();
      let res = await this.$api.newInsurance.getCardNoAPI()
      if (res.data.code == 0) {
        this.readType = 0
        this.$message.success("读取身份证号成功");
        console.log(res, "获取身份证号");
        const { model } = res.data;
        this.idCardData.mdtrt_cert_no = model.cardNo;
        this.idCardData.certno = model.cardNo;
        this.idCardData.psn_name = model.name;
        this.idCardForm = model
        if (this.idCardData.mdtrt_cert_no) {
          let formData = {
            ...this.idCardData,
            mdtrt_cert_type: this.cardReadingType,
            psn_cert_type: this.cardReadingType,
          }
          this.getPatientInfoByReadCard(formData);
          await this.$nextTick()
          this.cardReadingType = ''
        }
      } else {
        this.cardReadingType = ''
        this.$message.error(res.data.message || "读取身份证号失败，请检查是否放置身份证");
      }
    },
    // 初始化读卡
    async initReadCard () {
      const { fixMedIns } = this.countInfo
      const params = { url: fixMedIns.apiUrl, User: fixMedIns.useArea, };
      await this.$api.newInsurance.initReadCardAPI(params)
    },
    //  获取人员信息
    async getPatientInfoByReadCard (obj) {
      this.patientInfoParams = obj
      let res = await this.$api.newInsurance.getPatientInfoByReadCardAPI2({ ...obj, acctUsedFlag: this.acctUsedFlag, payMod: this.payMod })
      if (res.data.code == 200) {
        this.$message.success("获取人员信息成功");
        const { data } = res.data;
        console.log('data: ', data);
        this.personInfo = data
        this.form.psn_name = data.psnName;
        this.form.age = Math.floor(data.age);
        this.form.bir = data.brdy;
        this.form.certno = data.certno;
        this.form.gender = data.gend;
        this.form.naty = data.naty
        // this.patientInfoParams.readCardId = data.readCardId
        this.$set(this.form, 'insutype', data.personnelInsuinfoList[0].insutype)
      } else {
        this.$message.error(res.data.message);
      }
    },

    async queryCom (types, query) {
      let res = await this.$api.drugControl.searchDictionary({ type: types, cnName: query })
      const list = res.dictList.map(item => ({ ...item, value: item.cnName }));
      return list || [];
    },
    // 获取民族列表
    async getNationList () {
      this.nationList = await this.queryCom(29, '')
    },

    // 根据 x岁x月x日 计算出生日
    calculateBirthday (ageYears, ageMonths, ageDays) {
      // 获取当前日期
      var currentDate = new Date();

      // 计算出生日期
      var birthDate = new Date(
        currentDate.getFullYear() - ageYears,
        currentDate.getMonth() - ageMonths,
        currentDate.getDate() - ageDays
      );

      // 返回出生日期
      console.log('birthDate.toDateString(): ', birthDate.toDateString());
      let year = birthDate.getFullYear();
      let month = birthDate.getMonth() + 1;
      let day = birthDate.getDate();
      return year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day);
    },
    getBirthday () {
      const { year = 0, month = 0, day = 0 } = this.form;
      this.$set(this.form, 'bir', this.calculateBirthday(year, month, day));
      return this.form.bir;
    },
    // 根据生日计算年龄 返回 x岁x月x日 
    getAge () {
      // 将生日字符串转换为日期对象
      var birthdateObj = new Date(this.form.bir);
      // 获取当前日期
      var currentDate = new Date();
      // 计算年龄
      var year = currentDate.getFullYear() - birthdateObj.getFullYear();
      // 考虑生日还未到的情况
      if (currentDate.getMonth() < birthdateObj.getMonth() ||
        (currentDate.getMonth() === birthdateObj.getMonth() &&
          currentDate.getDate() < birthdateObj.getDate())) {
        year -= 1;
      }
      // 计算月份和天数
      var month;
      if (currentDate.getMonth() >= birthdateObj.getMonth()) {
        month = currentDate.getMonth() - birthdateObj.getMonth();
      } else {
        month = 12 - birthdateObj.getMonth() + currentDate.getMonth();
      }
      var day;
      if (currentDate.getDate() >= birthdateObj.getDate()) {
        day = currentDate.getDate() - birthdateObj.getDate();
      } else {
        // 处理月份天数不足情况
        month -= 1;
        var tempDate = new Date(currentDate.getFullYear(),
          currentDate.getMonth() - 1,
          currentDate.getDate());
        day = Math.floor((currentDate - tempDate) / (1000 * 60 * 60 * 24));
      }
      // 返回 x岁x月x日 
      this.$set(this.form, 'year', year);
      this.$set(this.form, 'month', month);
      this.$set(this.form, 'day', day);
    },
    async certNoChamge (e) {
      if (e && e.length == 18) {
        const bir = e.substring(6, 10) + '-' + e.substring(10, 12) + '-' + e.substring(12, 14);
        this.$set(this.form, 'bir', bir);
        await this.$nextTick()
        this.getAge();
      }
    },
    optionsLabelGetter
  },
  computed: {
    countInfo () {
      return Store.get("vuex").global.countInfo
    },
    isAdmin () {
      // 1 管理员 0 普通用户
      const { isAdmin } = this.countInfo
      return isAdmin
    },
    registerFlag () {
      // 有医生/药师编码和科室编码则可以挂号
      let flag = false
      if (!this.isAdmin) {
        flag = this.countInfo.hiHiCode && (this.countInfo.hiMedicineCode || this.countInfo.hiPhysicianCode)
      }
      return flag
    },
    isHiSuccess () {
      return this.$store.state.global.isHiSuccess
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-loading-spinner {
  top: 80px;
}

.select-left {
  :deep(.el-input__inner) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
}

.select-center {
  :deep(.el-input__inner) {
    border-radius: 0;
  }
}


.select-right {
  :deep(.el-input__inner) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}


:deep(.reading-type) {

  .is-checked {
    background-color: #00968850 !important;
    border-color: #009688;

    .el-radio__label {
      color: #009688;
    }
  }

  .el-radio {}

  .el-radio__input {
    display: none !important;
  }
}

.pending {
  color: #009688;
  font-weight: 500;
}

.cancelText {
  color: #fa0707;
  font-weight: 500;
}

.age-box {
  width: 100%;
  display: flex;
  align-items: center;

  :deep(.el-input) {

    .el-input-group__append,
    .el-input__inner {
      border-radius: 0;

    }

    &:first-child {
      .el-input__inner {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
      }


    }

    .el-input-group__append {
      padding: 0 10px;
      border-right-width: 0;
      background-color: #fff;
      color: #606266;
    }

    // .el-input__inner {
    //   border-right-width: 0;

    //   &:hover,
    //   &:focus {
    //     border-right-width: 1px;
    //   }
    // }

    &:last-child {
      .el-input-group__append {
        border-right-width: 1px;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
      }
    }
  }
}
</style>